import { render, staticRenderFns } from "./CompetitorsFooter.vue?vue&type=template&id=0ca46b2e&scoped=true&"
import script from "./CompetitorsFooter.vue?vue&type=script&lang=ts&"
export * from "./CompetitorsFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca46b2e",
  null
  
)

export default component.exports